#import "~/graphql/fragments/CoreEntryFields.graphql"
#import "~/graphql/fragments/Components/VizyBlocks.graphql"
#import "~/graphql/fragments/Components/ContactForm.graphql"
#import "~/graphql/fragments/seomatic.graphql"
#import "~/graphql/fragments/Components/Newsletter.graphql"

query StoryEntry($uri: [String], $site: [String] = "nl") {
    entry(uri: $uri, site: $site, section: "stories") {
        ...CoreEntryFields
        ...SeomaticFields

        ... on story_Entry {
            showContactForm

            contactForm {
                
                    ... ContactForm
                
            }

            newsletterBlock {
                
                    ...Newsletter
                
            }

            contentBuilder {
                ...VizyBlocks
            }

            contentHero {
                
                    ... on contentHeroBlock_Entry {
                        image {
                            url
                            width
                            height
                            title
                            w113: url @transform(width: 113, format: "webp", mode: "crop")
                            w226: url @transform(width: 226, format: "webp", mode: "crop")
                            w418: url @transform(width: 418  format: "webp", mode: "crop")
                            w113_avif: url @transform(width: 113, format: "avif", mode: "crop")
                            w226_avif: url @transform(width: 226, format: "avif", mode: "crop")
                            w418_avif: url @transform(width: 418, format: "avif", mode: "crop")
                        }
                        id
                        title
                        description
                        caption
                        backgroundColor
                        imagePosition
                    }
                
            }
        }
    }
}
